import navigation from "@/lang/en_GB/navigation";
import generics from "@/lang/en_GB/generics";
import questions from "@/lang/en_GB/questions";
import a11y from "@/lang/en_GB/a11y";
import velt from "@/lang/en_GB/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
